import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  optVaahan: false,
  category: "Post",
  link: "",
  apiDescription: ["Name", "Case ID"],
  newDescription: "",
};

const apiFormSlice = createSlice({
  name: "apiForm",
  initialState,
  reducers: {
    setOptVaahan: (state, action) => {
      state.optVaahan = action.payload;
    },
    setCategory: (state, action) => {
      state.category = action.payload;
    },
    setLink: (state, action) => {
      state.link = action.payload;
    },
    setNewDescription: (state, action) => {
      state.newDescription = action.payload;
    },
    addDescription: (state) => {
      if (state.newDescription.trim() !== "") {
        state.apiDescription.push(state.newDescription.trim());
        state.newDescription = "";
      }
    },
    removeDescription: (state, action) => {
      state.apiDescription = state.apiDescription.filter((_, i) => i !== action.payload);
    },
    resetApiFormState: (state) => {
      Object.assign(state, initialState);
    },
  },
});

export const apiFormActions = apiFormSlice.actions;
export default apiFormSlice;
